export const ANALYTICS_PROPERTY_KEYS = {
  PAGE_PATH: 'page_path',
  PAGE: 'page',
  DURATION_MS: 'duration_ms',
  CAMPAIGN_ID: 'campaign_id',
  CAMPAIGN_NAME: 'campaign_name',
  AD_ACCOUNT_ID: 'ad_account_id',
  LINE_ITEM_ID: 'line_item_id',
  REVISION_NUMBER: 'revision_number',
  IS_VALIDATED_EDIT: 'is_validated_edit',
  LINE_ITEM_NAME: 'line_item_name',
  BUDGET: 'budget',
  BUDGET_AMOUNT: 'budget_amount',
  FROM_BUDGET: 'from_budget',
  TO_BUDGET: 'to_budget',
  FROM_START_DATE: 'from_start_date',
  TO_START_DATE: 'to_start_date',
  FROM_END_DATE: 'from_end_date',
  TO_END_DATE: 'to_end_date',
  FROM_TARGETING_TYPES: 'from_targeting_types',
  TO_TARGETING_TYPES: 'to_targeting_types',
  FROM_STATUS: 'from_status',
  TO_STATUS: 'to_status',
  UNAVAILABLE_REASON: 'unavailable_reason',
  ERROR_TYPE: 'error_type',
  ERROR_SEVERITY: 'error_severity',
  ERROR_ID_HASH: 'error_id_hash',
  GRAPHQL_OPERATION: 'graphql_operation',
  PRODUCT_ID: 'product_id',
  PRODUCT_ENVIRONMENT: 'product_environment',
  AUTH_STATE: 'auth_state',
  START_DATE: 'start_date',
  END_DATE: 'end_date',
  PUBLISHER: 'publisher',
  PACKAGE_ID: 'package_id',
  PACKAGE_NAME: 'package_name',
  AD_FORMAT: 'ad_format',
  AD_DURATION: 'ad_duration',
  PACING_TYPE: 'pacing_type',
  FREQUENCY: 'frequency',
  FREQUENCY_CAP_UNIT: 'frequency_cap_unit',
  ALLOW_MATURE_CONTENT: 'allow_mature_content',
  IS_PREEMPTIBLE: 'is_preemptible',
  HAS_DNA_APPLIED: 'has_dna_applied',
  AGE_GROUP_COUNT: 'age_group_count',
  GENDER_COUNT: 'gender_count',
  STATE_COUNT: 'state_count',
  CITY_COUNT: 'city_count',
  DMA_COUNT: 'dma_count',
  ZIP_CODE_COUNT: 'zip_code_count',
  PLATFORM_COUNT: 'platform_count',
  AUDIENCE_COUNT: 'audience_count',
  CONTENT_COUNT: 'content_count',
  RETARGETING_COUNT: 'retargeting_count',
  AD_COUNT: 'ad_count',
  AD_IDS: 'ad_ids',
  AD_WEIGHTS: 'ad_weights',
  DAYPART_SCHEDULE_COUNT: 'daypart_schedule_count',
  PACING_SCHEDULE_COUNT: 'pacing_schedule_count',
  AGE_GROUPS: 'age_groups',
  GENDERS: 'genders',
  STATES: 'states',
  CITIES: 'cities',
  DMAS: 'dmas',
  ZIP_CODES: 'zip_codes',
  PLATFORMS: 'platforms',
  AUDIENCES: 'audiences',
  CONTENT_TARGETINGS: 'content_targetings',
  RETARGETINGS: 'retargetings',
  AD_NAMES: 'ad_names',
  SELECTED_LINE_ITEM_COUNT: 'selected_line_item_count',
  LINE_ITEM_IDS: 'line_item_ids',
  ORGANIZATION_ID: 'organization_id',
  ORGANIZATION_NAME: 'organization_name',
  HAD_MFA: 'had_mfa',
  IS_SLOW: 'is_slow',
  TIME_ON_PAGE_MS: 'time_on_page_ms',
  METRIC_VALUE: 'metric_value',
  RELEASE_ID: 'release_id',
  ENVIRONMENT: 'environment',
  REPORT_NAME: 'report_name',
  REPORT_TYPE: 'report_type',
  ELEMENT_SELECTOR: 'element_selector',
  CLICK_COUNT: 'click_count',
  CREATIVE_ID: 'creative_id',
  CREATIVE_STATUS: 'creative_status',
  ASSET_ID: 'asset_id',
  ASSET_SOURCE_ID: 'asset_source_id',
  ASSET_TYPE: 'asset_type',
  UPLOAD_SOURCE: 'upload_source',
  BROWSE_ACTION: 'browse_action',
  COMPONENT_OUTCOME: 'component_outcome',
  CREATION_TYPE: 'creation_type',
  SOURCE_CAMPAIGN_ID: 'source_campaign_id',
  SOURCE_LINE_ITEM_ID: 'source_line_item_id',
  INVENTORY_PERCENTAGE: 'inventory_percentage',
  REJECTION_SOURCE: 'rejection_source',
  REJECTION_REASON_COUNT: 'rejection_reason_count',
  REJECTION_REASONS: 'rejection_reasons',
  BRAND_ID: 'brand_id',
  GALLERY_TAB: 'gallery_tab',
  GALLERY_ACTION: 'gallery_action',
  GALLERY_ENTITY_TYPE: 'gallery_entity_type',
  NAVIGATION_DESTINATION: 'navigation_destination',
  HAS_INVENTORY_SUGGESTIONS: 'has_inventory_suggestions',
  SEARCH_QUERY: 'search_query',
  CONFIGURATION_ID: 'configuration_id',
  STEP_NAME: 'step_name',
  FIELD_NAME: 'field_name',
  ERROR_CODE: 'error_code',
  INTERACTION_TYPE: 'interaction_type',
  TOOLTIP_ID: 'tooltip_id',
  ELEMENT_LABEL: 'element_label',
  EDIT_TYPE: 'edit_type',
  POLITICAL_CLASSIFICATION: 'political_classification',
  INDUSTRY_VERTICAL: 'industry_vertical',
  USER_ROLE: 'user_role',
  DCM_USER_ROLE: 'dcm_user_role',
  HAS_ADVANCED_DELIVERY_CONTROLS: 'has_advanced_delivery_controls',
  HAS_PREMIUM_CONTENT_TARGETING: 'has_premium_content_targeting',
  IS_BASE_TARGETING: 'is_base_targeting',
  TARGETING_TYPES: 'targeting_types',
  AUDIENCE_IDS: 'audience_ids',
  AUDIENCE_NAMES: 'audience_names',
  AUDIENCES_ADDED_COUNT: 'audiences_added_count',
  AUDIENCES_REMOVED_COUNT: 'audiences_removed_count',
  AUDIENCE_IDS_ADDED: 'audience_ids_added',
  AUDIENCE_IDS_REMOVED: 'audience_ids_removed',
  AUDIENCE_NAMES_ADDED: 'audience_names_added',
  AUDIENCE_NAMES_REMOVED: 'audience_names_removed',
  GENRE_IDS: 'genre_ids',
  GENRE_NAMES: 'genre_names',
  GENRE_COUNT: 'genre_count',
  GENRE_IDS_ADDED: 'genre_ids_added',
  GENRE_IDS_REMOVED: 'genre_ids_removed',
  GENRE_ADDED_NAME: 'genre_added_name',
  GENRE_REMOVED_NAME: 'genre_removed_name',
  GENRE_ADDED_COUNT: 'genre_added_count',
  GENRE_REMOVED_COUNT: 'genre_removed_count',
  INCLUDED_GENRE_NAMES: 'included_genre_names',
  EXCLUDED_GENRE_NAMES: 'excluded_genre_names',
  LOCATION_IDS: 'location_ids',
  LOCATION_NAMES: 'location_names',
  LOCATION_SELECTION_COUNT: 'location_selection_count',
  LOCATION_IDS_ADDED: 'location_ids_added',
  LOCATION_IDS_REMOVED: 'location_ids_removed',
  LOCATION_ADDED_NAME: 'location_added_name',
  LOCATION_REMOVED_NAME: 'location_removed_name',
  LOCATION_ADDED_COUNT: 'location_added_count',
  LOCATION_REMOVED_COUNT: 'location_removed_count',
  INCLUDED_LOCATION_NAMES: 'included_location_names',
  EXCLUDED_LOCATION_NAMES: 'excluded_location_names',
} as const;
